export default {
      id: "video-event_power-lost-usage",
      viewBox: "0 0 33 33",
      url: __webpack_public_path__ + "img/icons.svg#video-event_power-lost",
      toString: function () {
        return this.url;
      }
    }